import { useEffect, useState } from "react";
import { Ghost } from "lucide-react";
import { Header } from "./common/Header";
import { Button } from "./ui/button";
import { BottomNavigation } from "./ui/BottomNavigation";
import { useNavigate } from "react-router";

export const NotFoundPage = () => {
  const [animationStep, setAnimationStep] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const steps = [
      { delay: 0, step: 0 },
      { delay: 400, step: 1 },
      { delay: 1200, step: 2 },
    ];
    steps.forEach(({ delay, step }) => {
      setTimeout(() => setAnimationStep(step), delay);
    });
  }, []);

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 flex flex-col">
      <Header title="Page Not Found" showBackButton={false} />
      <div className="flex-1 flex flex-col items-center justify-center pt-24 pb-32 px-5 text-center">
        <div className="relative mb-8">
          <div
            className={`w-28 h-28 bg-gray-100 rounded-full flex items-center justify-center mx-auto transition-all duration-700 ${
              animationStep >= 1 ? "scale-100 opacity-100" : "scale-0 opacity-0"
            }`}
          >
            <Ghost className="w-14 h-14 text-gray-400 animate-bounce" />
          </div>
          {/* Floating dots animation */}
          {animationStep >= 2 && (
            <div className="absolute inset-0 pointer-events-none">
              {[...Array(8)].map((_, i) => (
                <div
                  key={i}
                  className="absolute w-2 h-2 bg-primary-blue rounded-full animate-ping"
                  style={{
                    left: `${40 + 30 * Math.cos((i / 8) * 2 * Math.PI)}%`,
                    top: `${40 + 30 * Math.sin((i / 8) * 2 * Math.PI)}%`,
                    animationDelay: `${i * 0.15}s`,
                  }}
                />
              ))}
            </div>
          )}
        </div>
        <h2 className="text-2xl font-bold text-black mb-2 transition-all duration-700 delay-300">
          Oops! Page Not Found
        </h2>
        <p className="text-gray-600 mb-8 max-w-sm mx-auto transition-all duration-700 delay-500">
          The page you are looking for doesn&apos;t exist or has been moved. Let&apos;s get you back home!
        </p>
        <Button
          onClick={handleGoHome}
          className="px-8 py-3 rounded-full font-semibold"
        >
          Go to Home
        </Button>
      </div>
      <BottomNavigation />
    </div>
  );
}; 